<template>
  <div :class="`col-auto messages chat-canvas ${isLoading ? 'row justify-center' : ''}`">
    <div
      class="col-auto"
      v-if="isLoading"
    >
      <q-spinner-ios
        v-once
        color="primary"
        size="3em"
      />
    </div>

    <q-virtual-scroll
      v-else
      style="height: 300px; max-height: 300px; width: 100%"
      class="column full-width q-px-md q-py-sm"
      :items="messages"
      :virtual-scroll-slice-size="60"
      :virtual-scroll-slice-ratio-before="5"
      :virtual-scroll-slice-ratio-after="5"
    >
      <template #default="{ item }">
        <AttendanceChatNote
          v-if="item.type === aiNoteType"
          :key="item.id"
          :note="item"
        />
        <AttendanceChatMessage
          v-else
          :key="item.id"
          :msg="item"
        />
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import api from '@/libs/api'
import AttendanceChatMessage from '@/components/AttendanceChatMessage'
import AttendanceChatNote from '@/components/AttendanceChatNote'
import { AI_NOTE_TYPE, interleaveAgentNotes, toAgentNotes } from '@/libs/agentNotes'
import { getMessageStatus } from '@/libs/helpers'

export default {
  props: {
    attendanceId: {}
  },
  components: {
    AttendanceChatMessage,
    AttendanceChatNote
  },

  data () {
    return {
      aiNoteType: AI_NOTE_TYPE,
      isLoading: true,
      messages: []
    }
  },

  mounted () {
    const vm = this
    vm.$nextTick().then(() => vm.loadMessages())
  },

  methods: {
    loadMessages () {
      const vm = this

      const queryParams = {
        page: 1,
        limit: 99999,
        byChatId: true
      }

      api.loadChatMessages(vm.attendanceId, queryParams).then(({ messages, notes }) => {
        const timeline = Array.isArray(messages)
          ? messages.map((msg) => Object.assign({}, msg, getMessageStatus(msg))).reverse()
          : []

        vm.messages = interleaveAgentNotes(timeline, toAgentNotes(notes))

        vm.isLoading = false
      })
    }
  }
}

</script>

<style lang="sass">

  .messages
    .q-virtual-scroll__content
      width: 100%

  .chat-canvas
    background: rgba(239, 234, 226, 0.5) url('/icons/chat-bg.png') repeat
</style>
